import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const categoryListApi = async (data) => {
  const endPoint = `admin/category/list?${new URLSearchParams(
    data
  ).toString()}`;

  return await axios.get(endPoint, setJwtToken());
};

export const updateCategoryApi = async (data) => {
  const endPoint = `admin/category`;
  return await axios.put(endPoint, data, setJwtToken());
};
// ------------------------Edit category------------------
// export const addOrUpdatCategory = async (data) => {
//     const endPoint = `category/add_update`;
//     return await axios.post(endPoint, data, setMultiPartHeader());
// };
// // -----------------------change status and delete category----------------------------
// export const updateStatus = async (data) => {
//     const endPoint = `category/updateCategory`;
//     return await axios.post(endPoint, data, setMultiPartHeader());
// };
// // -----------------------------add subCategory---------------------------------------
export const addSuveyCategory = async (data) => {
  const endPoint = `admin/category`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateSuveyCategory = async (data) => {
  const endPoint = `admin/category`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};

// Delete Survey Category
export const deleteSurveyCategory = async (data) => {
  const endPoint = `admin/category?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};
